<template>
    <div class="simple-dashboard-view pointer-events-none flex relative flex-col dashboard-wrapper">
        <RedesignAppNavbar
            key="redesign-base-navbar"
            layout-type="previewLayout"
        >
            <template #dashboard-operations>
                <div class="flex items-center">
                    <RedesignLayoutSwitcher
                        :active-type="layoutTypes.TABBED"
                    />
                </div>
            </template>
        </RedesignAppNavbar>
        <AccountNoData v-if="!dashboard" />
        <div
            v-else
            class="dashboard"
        >
            <div
                class="dashboard-container min-h-screen mb-10"
            >
                <RedesignAppTopBar
                    red="appTopBarRef"
                    :tabbed-view="true"
                    :active-tab="activeWidgetGroupID"
                    :widget-group-list="activeDashboardWidgetGroups"
                    :edit-mode="false"
                    :full-screen="false"
                    preview-mode
                    @switch-tab="onSwitchTab"
                />
                <div class="pt-5" />
                <div
                    v-if="noDataGroups"
                    class="p-10 w-full h-full flex-center min-h-[460px]"
                >
                    <div>
                        <IconNoData
                            class="h-56 w-56 text-gray-500"
                        />
                    </div>
                </div>
                <div
                    v-else
                    :key="activeWidgetGroupID"
                    class="p-1"
                >
                    <TabbedView
                        v-if="activeWidgetGroup"
                        :layout-type="getCurrentLayoutType"
                        :edit-mode="false"
                        :widget-group="activeWidgetGroup"
                        :preview-mode="true"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignAppNavbar from '@/components/RedesignComponents/App/RedesignAppNavbar.vue'
import RedesignLayoutSwitcher from '@/components/RedesignComponents/Navbar/RedesignLayoutSwitcher.vue'
import { layoutTypes } from '@/enum/layout'
import AccountNoData from '@/views/AccountNoData.vue'
import { IExtendedDashboard, WidgetGroupList } from '@/types/dashboard'
import RedesignAppTopBar from '@/components/RedesignComponents/App/RedesignAppTopBar.vue'
import { computed, ref, watch } from 'vue'
import { getCurrentLayoutType } from '@/composables/useLayoutType'
import TabbedView from '@/components/LayoutRendering/Types/TabbedView.vue'

const props = defineProps<{
    dashboard?: IExtendedDashboard
}>()

const activeDashboardWidgetGroups = ref<Array<WidgetGroupList>>([])
const activeWidgetGroupID = ref(0)

const noDataGroups = computed(() => {
    return !(props.dashboard?.WidgetGroupList?.length)
})
const activeWidgetGroup = computed(() => {
    return props.dashboard?.WidgetGroupList?.find((widgetGroup) => widgetGroup.WidgetGroupID === activeWidgetGroupID.value)
})

function onSwitchTab (groupID: number) {
    activeWidgetGroupID.value = groupID
}
function setActiveDashboardWidgetGroups () {
    const list = props.dashboard?.WidgetGroupList || []
    activeDashboardWidgetGroups.value = [ ...list ].sort((a, b) =>  a.Order - b.Order)
        .map((widgetGroup) => {
            return {
                ...widgetGroup,
                WidgetList: widgetGroup.WidgetList?.sort((a, b) => (a.WidgetLayout.Order || 0) - (b.WidgetLayout.Order || 0)),
            }
        })
    activeWidgetGroupID.value = activeDashboardWidgetGroups.value[0]?.WidgetGroupID
}

watch(
    () => props.dashboard,
    () => {
        setActiveDashboardWidgetGroups()
    },
    { immediate: true }
)
</script>
